import { render, staticRenderFns } from "./shortLinkCard.vue?vue&type=template&id=67a4ad27&scoped=true"
import script from "./shortLinkCard.vue?vue&type=script&lang=js"
export * from "./shortLinkCard.vue?vue&type=script&lang=js"
import style0 from "./shortLinkCard.vue?vue&type=style&index=0&id=67a4ad27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a4ad27",
  null
  
)

export default component.exports